import type { ReactNode } from 'react';
import { CardLoader, type CardLoaderProps } from './CardLoader';
import { cardClassName } from './cardClassName';

export interface CardProps extends Omit<CardLoaderProps, 'children'> {
  children: ReactNode;
  className?: string;
  withPadding?: boolean;
}

export const Card = ({ children, className, withPadding = true, ...rest }: CardProps) => (
  <CardLoader {...rest} loaderClassNames={{ ...rest.loaderClassNames, error: className }}>
    <div className={cardClassName(withPadding, className)}>{children}</div>
  </CardLoader>
);
